import { get, handleError, put } from '@/lib/http-adapter';
import { BookedListItem } from '@/state/booked-classes';
import { User } from '@/state/user';

export const getCurrentUser = async () => {
  try {
    const { user } = await get<{ user: User }>('/public/users/me');
    return user;
  } catch (error) {
    handleError(error);
  }
};

export const updateCurrentUserDetails = async (
  userDetailsPayload: Partial<User>
) => {
  try {
    return await put('/public/users/me', {
      ...userDetailsPayload,
    });
  } catch (error) {
    handleError(error);
  }
};

export const getBookedClasses = async (
  email: string,
  type: 'upcoming' | 'past' = 'upcoming'
) => {
  try {
    const response = await get<{
      classes: BookedListItem[];
    }>(`/public/users/${email}/classes`, { params: { type } });

    return response.classes;
  } catch (error) {
    handleError(error);
  }
};
